<input
  type="checkbox"
  [id]="id()"
  [checked]="checked()"
  [disabled]="disabledState()"
  (change)="handleSwitchChange($event)"
  (blur)="handleSwitchBlur()"
  class="tw:sr-only tw:peer"
  aria-label="Switch"
  role="switch"
  [attr.aria-checked]="checked()"
  [attr.aria-disabled]="disabledState()"
  [attr.aria-labelledby]="`${id()}-label`"
/>

<label [for]="id()" [ngClass]="switchLabelClasses()" [attr.id]="`${id()}-label`">
  @if (labelPosition() === "before") {
    <ng-container *ngTemplateOutlet="labelText"></ng-container>
  }
  <div
    class="tw:relative tw:inline-flex tw:h-6 tw:w-10 tw:min-w-10 tw:items-center tw:rounded-3xl tw:transition-colors tw:duration-200 tw:ease-in-out"
    [ngClass]="currentColor().bg"
  >
    <div
      class="tw:inline-block tw:h-5 tw:w-5 tw:rounded-full tw:shadow tw:transform tw:ring-0 tw:transition tw:duration-200 tw:ease-in-out"
      [ngClass]="[checked() ? 'tw:translate-x-4.5' : 'tw:translate-x-0.5', currentColor().handleBg]"
    ></div>
  </div>
  @if (labelPosition() === "after") {
    <ng-container *ngTemplateOutlet="labelText"></ng-container>
  }
</label>

<ng-template #labelText>
  <span class="tw:empty:hidden tw:min-w-0">
    <ng-content></ng-content>
  </span>
</ng-template>
